import React from "react";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

export default function Layout() {
    return (
        <>
            <Header />
            <Sidebar />
            <Outlet />
        </>
    )
}
